export const NO_FILTER_RESULTS =
    'No results found for specified filter criteria'
